// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Typography from "@mui/material/Typography";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

type BrowserType = {
  title: string;
};

const Browser = ({ title }: BrowserType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <OperatingManualContent title={title}>
      <Typography>
        {t(
          "The RVF200 web portal supports the latest versions from Chrome, Edge, Safari and Firefox."
        )}
      </Typography>
    </OperatingManualContent>
  );
};

export default Browser;
